import { Link, type LinkProps } from '../Link/Link';
import { CSSPropsVars } from '@/interfaces/types/CSSPropsVars';

export interface LinkWrapperIfHrefProps {
    className?: string;
    style?: CSSPropsVars;
    link?: LinkProps;
    children: React.ReactNode;
    downloadable?: boolean;
    dataCy?: string;
    forceContainer?: boolean;
}

export function LinkWrapperIfHref({
    className,
    style,
    link,
    children,
    downloadable,
    dataCy,
    forceContainer,
}: LinkWrapperIfHrefProps): React.JSX.Element {
    return link?.href ? (
        <Link
            className={className}
            style={style}
            href={link.href}
            target={link.target}
            aria-label={link['aria-label']}
            download={downloadable}
            dataCy={dataCy}
        >
            {children}
        </Link>
    ) : (
        <WithDivWrapperIfForceClassOrStyle className={className} style={style} forceContainer={forceContainer}>
            {children}
        </WithDivWrapperIfForceClassOrStyle>
    );
}

function WithDivWrapperIfForceClassOrStyle({
    className,
    style,
    forceContainer,
    children,
}: Pick<LinkWrapperIfHrefProps, 'className' | 'style' | 'forceContainer' | 'children'>): React.JSX.Element {
    return className || style || forceContainer ? (
        <div className={className} style={style}>
            {children}
        </div>
    ) : (
        <>{children}</>
    );
}
